import AppLayout from "../components/common/AppLayout";

export default function ConfiguracionPage() {
    return (
        <AppLayout title="Configuración">
            <div className="card-panel">
                <h3>Configuración general</h3>
                <p>Aquí podrás administrar monedas, categorías, subcategorías, métodos de pago y parámetros globales.</p>
            </div>
        </AppLayout>
    );
}